<template>
  <div :style="themeVars">
    <v-card class="group-card" elevation="2">
      <v-card-text class="pb-2">
        <div class="d-flex align-center justify-space-between mb-4">
          <div>
            <div class="group-card__eyebrow">Turma disponível</div>
            <div class="text-h5 font-weight-bold">Turma {{ item.cod }}</div>
          </div>
          <v-chip small color="primary-50" text-color="primary-700">
            {{ item.availableSpots }} vaga{{
              item.availableSpots === 1 ? "" : "s"
            }}
          </v-chip>
        </div>

        <div class="group-card__teacher mb-4">
          <v-avatar color="primary-500" size="52" class="mr-3">
            <span class="white--text font-weight-bold">
              {{ teacherInitials }}
            </span>
          </v-avatar>
          <div>
            <div class="group-card__label">Professor responsável</div>
            <div class="group-card__value">{{ item.teacher?.name || "-" }}</div>
          </div>
        </div>

        <v-row dense>
          <v-col cols="12" sm="6">
            <div class="group-card__meta">
              <span class="group-card__label">Nível</span>
              <strong class="group-card__value">
                {{ displayGroupLevel(item.level) }}
              </strong>
            </div>
          </v-col>
          <v-col cols="12" sm="6">
            <div class="group-card__meta">
              <span class="group-card__label">Formato</span>
              <strong class="group-card__value">
                {{ displayGroupFormat(item.format) }}
              </strong>
            </div>
          </v-col>
          <v-col cols="12" sm="6">
            <div class="group-card__meta">
              <span class="group-card__label">Frequência</span>
              <strong class="group-card__value">
                {{ displayGroupFrequency(item.frequency) }}
              </strong>
            </div>
          </v-col>
          <v-col cols="12" sm="6">
            <div class="group-card__meta">
              <span class="group-card__label">Alunos ativos</span>
              <strong class="group-card__value">
                {{ item.studentsCount }} / {{ item.capacity }}
              </strong>
            </div>
          </v-col>
        </v-row>

        <div class="group-card__schedule mt-4">
          <div class="group-card__label mb-2">Horários da turma</div>
          <div v-if="normalizedTimes.length" class="d-flex flex-wrap">
            <v-chip
              v-for="slot in normalizedTimes"
              :key="`${slot.weekDay}-${slot.start}-${slot.end}`"
              small
              outlined
              color="primary-500"
              class="mr-2 mb-2"
            >
              {{ weekDayLabel(slot.weekDay) }} - {{ slot.start }} às
              {{ slot.end }}
            </v-chip>
          </div>
          <span v-else class="caption grey--text">
            Horários da turma não informados.
          </span>
        </div>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-btn
          block
          rounded
          color="primary-500"
          class="white--text"
          @click="$emit('requestJoin', item)"
        >
          Solicitar entrada na turma
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Colors from "@/styles/app.module.scss";
import {
  WEEK_DAY_ITEMS,
  displayGroupFormat,
  displayGroupFrequency,
  displayGroupLevel,
  initialsFromName,
  normalizeClassTimes,
} from "@/shared/classPresentation";

export default {
  name: "MatchedGroupCard",

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    themeVars() {
      return {
        "--customer-primary": Colors["primary-500"],
        "--customer-primary-soft": Colors["primary-50"],
      };
    },
    normalizedTimes() {
      return normalizeClassTimes(this.item.weekDays, this.item.hours);
    },
    teacherInitials() {
      return initialsFromName(this.item.teacher?.name || "PE");
    },
  },

  methods: {
    displayGroupLevel,
    displayGroupFormat,
    displayGroupFrequency,
    weekDayLabel(day) {
      return WEEK_DAY_ITEMS.find((item) => +item.value === +day)?.text || "-";
    },
  },
};
</script>

<style scoped>
.group-card {
  width: 100%;
  border-radius: 28px 16px 28px 16px;
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    rgba(255, 255, 255, 0.96) 100%
  );
}

.group-card__eyebrow {
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--customer-primary);
  font-weight: 700;
}

.group-card__teacher {
  display: flex;
  align-items: center;
  padding: 0.9rem 1rem;
  border-radius: 18px;
  background: var(--customer-primary-soft);
}

.group-card__meta {
  display: flex;
  flex-direction: column;
  padding: 0.85rem 1rem;
  border-radius: 18px;
  background: rgba(20, 20, 31, 0.03);
  min-height: 92px;
}

.group-card__label {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgba(20, 20, 31, 0.58);
  margin-bottom: 0.35rem;
}

.group-card__value {
  font-size: 1rem;
  color: #1f2430;
}

.group-card__schedule {
  border-top: 1px solid rgba(20, 20, 31, 0.08);
  padding-top: 1rem;
}
</style>
